__turbopack_context__.v({
  "articleLeft": "help-module-scss-module__Tz9ySW__articleLeft",
  "articleTitle": "help-module-scss-module__Tz9ySW__articleTitle",
  "categoryTitle": "help-module-scss-module__Tz9ySW__categoryTitle",
  "lcResourcesContainer": "help-module-scss-module__Tz9ySW__lcResourcesContainer",
  "prequal": "help-module-scss-module__Tz9ySW__prequal",
  "sgiCalculator": "help-module-scss-module__Tz9ySW__sgiCalculator",
});
